import { Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDrawer } from '@angular/material/sidenav';
import { ServicesService } from '../my-profile/services.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserDetailsService } from '../services/user-details.service';
import { HttpClientModule } from '@angular/common/http';
import { ApiServicesService } from '../services/api-services.service';
import { ChangeDetectionStrategy, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SnackbarService } from '../services/snackbar.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-search-drawer',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatButtonModule, MatSidenavModule, MatSelectModule, MatFormFieldModule, ReactiveFormsModule, CommonModule, MatExpansionModule, MatCheckboxModule],
  templateUrl: './search-drawer.component.html',
  styleUrl: './search-drawer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchDrawerComponent {



  readonly panelOpenState = signal(false);
  @ViewChild('drawer') drawer!: MatDrawer;
  private taskservices = inject(ServicesService);
  formGroup: FormGroup;
  countrys: any;
  state: any;
  city: any;

  dropDownData: any;
  userData: any;
  my_gender: any;
  to_age: any = '';
  toage = 18;
  ageOptions: number[] = [];
  toageOptions: number[] = [];
  seekingArray: string[] = []; // Array for seeking values
  petsArray: string[] = []; // Array for pets values
  seekingFor: any;
  friends: any;
  formval: any;
  is_load_draw = false;
  @Output() messageEvent = new EventEmitter<number>();
  private drawerSubscription!: Subscription;



  constructor(private route: ActivatedRoute, private fb: FormBuilder, public apiservices: ApiServicesService, private userdetails: UserDetailsService, private snackbarService: SnackbarService) {
    this.formGroup = this.fb.group({
      gender: [''],
      seeking: [''],
      country: [''],
      state: [''],
      city: [''],
      age_from: [''],
      age_to: [''],
      pictures: [''],
      online: ['']
    });


    // Object.keys(this.formGroup.controls).forEach((key) => {
    //   const control = this.formGroup.get(key);
    //   if (control) {
    //     control.valueChanges.subscribe((value) => {
    //       this.onValueChanged(key, value);
    //     });
    //   }
    // });
  }




  // onValueChanged(key: string, value: boolean): void {
  //   if (key.startsWith('seeking')) {
  //     // Update seekingArray
  //     this.updateArray(this.seekingArray, key, value);
  //   } else if (key.startsWith('pet')) {
  //     // Update petsArray
  //     this.updateArray(this.petsArray, key, value);
  //   }

  //   // Log the current arrays for debugging
  // }

  updateArray(array: string[], key: string, value: boolean): void {
    if (value) {
      // Add the key to the array if checked
      if (!array.includes(key)) {
        array.push(key);
      }
    } else {
      // Remove the key from the array if unchecked
      const index = array.indexOf(key);
      if (index > -1) {
        array.splice(index, 1);
      }
    }
  }


  onCheckboxChange(type: 'seeking' | 'pets', value: string, isChecked: boolean): void {
    const targetArray = type === 'seeking' ? this.seekingArray : this.petsArray;

    if (isChecked) {
      // Add the value to the array if checked
      if (!targetArray.includes(value)) {
        targetArray.push(value);
      }
    } else {
      // Remove the value from the array if unchecked
      const index = targetArray.indexOf(value);
      if (index > -1) {
        targetArray.splice(index, 1);
      }
    }
  }

  ngOnInit() {
    const storedData = localStorage.getItem('formData');
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        this.formGroup.patchValue(parsedData);
        this.seekingArray = JSON.parse(parsedData.seeking_for || '[]');
        this.petsArray = JSON.parse(parsedData.pets || '[]');
      } catch (error) {
        console.error('Error parsing formData from localStorage:', error);
      }
    } else {
      this.userdetails.userdetails$.subscribe((userData) => {
        if (userData) {
          this.userData = userData;
          if (userData && userData.user) {
            this.formGroup.patchValue({
              gender: this.userData?.user?.gender?._id,
              seeking: this.userData?.user?.seeking_gender?._id,
            });
          }
        } else {

        }
      });
    }

    // this.userdetails.dropDownData$.subscribe((dropDownData) => {
    //   if (dropDownData) {
    //     this.dropDownData = dropDownData || {};
    //     this.countrys = this.dropDownData.countries || [];
    //     this.state = this.dropDownData.states || [];
    //     this.city = this.dropDownData.cities || [];
    //   }
    // });




    // const dropdownData = localStorage.getItem("AdvancedropdownData");
    // if (!dropdownData) {
    //   this.apiservices.getAdvanceDropdowndata().subscribe({
    //     next: (response: any) => {
    //       // this.userdetails.dropDownData.next(response.data);
    //       localStorage.setItem("AdvancedropdownData", JSON.stringify(response.data));
    //       // this.dropDownData = dropdownDataTemp || {};
    //     this.countrys = this.dropDownData.countries || [];
    //     this.state = this.dropDownData.states || [];
    //     this.city = this.dropDownData.cities || [];
    //     },
    //     error: (err) => {
    //       console.error('Error fetching states:', err);
    //     }
    //   });
    // }else{
    //   const parsedData = JSON.parse(dropdownData);
    //   // this.userdetails.dropDownData.next(parsedData);
    //   console.log(' parsedData', parsedData)

    // }






    this.generateNumbers(18, 90);
    this.generateToAge(this.toage, 90);

    this.drawerSubscription = this.taskservices.isDrawer$.subscribe((val) => {
      if (val === true) {
        this.openDrawer();
      }
    });



  }

  ngAfterViewInit(): void {
    // Open the drawer if the query param is true
    // this.route.queryParams.subscribe(params => {
    //   if (params['advancesearch'] === 'true') {
    //     this.openDrawer();
    //   }
    // });
  }

  ngOnDestroy() {
    if (this.drawerSubscription) {
      this.drawerSubscription.unsubscribe();
    }
  }

  onFromAgeChange(selectedAge: any): void {
    this.toage = this.formGroup.get('age_to')?.value;
    if (this.toage <= selectedAge) {
      this.toageOptions = [];
      this.formGroup.patchValue({
        age_to: '',
      })
    }
    if (selectedAge !== '') {
      this.toage = selectedAge;
    } else {
      this.toage = 18;
    }
    this.generateToAge(this.toage, 90);
  }

  // Generate an array of numbers from a starting point to an endpoint (used for age selection)
  generateNumbers(start: number, end: number): void {
    for (let i = start; i <= end; i++) {
      this.ageOptions.push(i);
    }
  }

  // Generate "To Age" options based on the selected "From Age"
  generateToAge(start: number, end: number): void {
    this.toageOptions = [];
    for (let i = start; i <= end; i++) {
      this.toageOptions.push(i);
    }
  }
  onCountryChange(event: MatSelectChange): void {
    const selectedCountryId = event.value;  // Get the selected country's ID
    if (selectedCountryId) {
      this.fetchStates(selectedCountryId);
    }
    this.formGroup.patchValue({
      state: '',  // Reset the country field (if required)
      city: '',
    });
  }
  onStateChange(event: MatSelectChange): void {
    const selectedCountryId = event.value;  // Get the selected country's ID
    if (selectedCountryId) {
      this.fetchcity(selectedCountryId);
    }
    this.formGroup.patchValue({
      // Reset the country field (if required)
      city: '',
    });

  }


  fetchcity(stateId: string): void {
    const countryId1 = { stateId: stateId }
    // Call your service to fetch states based on countryId
    this.apiservices.getCItyByStates(stateId).subscribe({
      next: (citys: any) => {
        this.city = citys;  // Store the fetched states in a variable
        this.city = this.city.data;
      },
      error: (err) => {
        console.error('Error fetching states:', err);
      }
    });
  }

  fetchStates(countryId: string): void {
    const countryId1 = { countryId: countryId }
    // Call your service to fetch states based on countryId
    this.apiservices.getStatesByCountry(countryId).subscribe({
      next: (states) => {

        const stateControl = this.formGroup.get('state');

        if (states.data.states.length === 0) {
          stateControl?.clearValidators(); // Remove required validation
          stateControl?.updateValueAndValidity(); // Ensure the form updates its state

          this.city = states?.data?.cities;
          this.state=states?.data?.states;

        } else {
          stateControl?.setValidators([Validators.required]); // Set required validation
          stateControl?.updateValueAndValidity(); // Ensure the validation is applied

          this.state = states?.data?.states;
        }
      },
      error: (err) => {
        console.error('Error fetching states:', err);
      }
    });
  }



  onSubmit() {
    if (this.is_load_draw == false) {
      this.is_load_draw = true;
      const formData = this.formGroup.value;
      // Construct the JSON object
      const formDataToSend = {
        seeking_for: JSON.stringify(this.seekingArray), // Convert array to JSON string
        pets: JSON.stringify(this.petsArray),
        country: formData.country || '',
        city: formData.city || '',
        seeking: formData.seeking || '',
        state: formData.state || '',
        isOnline: formData.online === '' ? null : formData.online === '0' ? false : true,
        gender: formData.gender || '',
        age_from: formData.age_from || '',
        age_to: formData.age_to || ''
      };
      this.searchdata(formDataToSend, 1, 10);
      localStorage.setItem('formData', JSON.stringify(formDataToSend));
      this.userdetails.setFormData(formDataToSend);

      const storedData = localStorage.getItem("AdvancedropdownData");
      if (storedData) {
        let parsedData = JSON.parse(storedData);
        parsedData.cities = this.city;
        parsedData.states = this.state;
        localStorage.setItem("AdvancedropdownData", JSON.stringify(parsedData));
      }

    }
  }


  searchdata(formdata: any, page: any, limit: any) {
    this.formval = formdata; // Parse the string into an object

    const petsArray = this.formval.pets ? JSON.parse(this.formval.pets) : [];
    const seekingForArray = this.formval.seeking_for ? JSON.parse(this.formval.seeking_for) : [];

    const pets = petsArray.length === 0 ? null : petsArray;
    const seekingFor = seekingForArray.length === 0 ? null : seekingForArray;

    this.apiservices
      .searchMembers(
        page,
        this.formval.gender,
        this.formval.seeking,
        this.formval.country,
        this.formval.state,
        this.formval.city,
        this.formval.age_from,
        this.formval.age_to,
        this.formval.isOnline,
        pets,          // Null if empty array
        seekingFor,    // Null if empty array
        limit,
      )
      .subscribe({
        next: (data: any) => {
          this.is_load_draw = false;
          if (data.status == 200) {
            this.is_load_draw = false;
            const friends = data; // Assign data to friends
            this.taskservices.setSearchdata(friends); // Save data to the task service
            // Stop the loading indicator
            this.drawer.close(); // Close the drawer
          } else {
            this.drawer.close();
            this.is_load_draw = false;
            this.taskservices.clearSearchdata(); // Save data to the task service
            this.snackbarService.openCustomSnackbar(
              {
                icon: false,
                message: data.message,
                className: 'failed',
              }
            );
            this.is_load_draw = false;
          }
        },
        error: (error) => {
          console.error('Error fetching search data:', error); // Log the error for debugging
          this.is_load_draw = false; // Stop the loading indicator
          this.drawer.close(); // Close the drawer
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: error.error.message,
              className: 'failed',
            }
          );
        },
      });
  }

  openDrawer() {
    if (this.drawer) {
      this.drawer.open();

    } else {
      console.error("Drawer is not available");
    }
    this.dropdownValues();
  }

  closeDrawer() {
    this.drawer.close();
    // console.log('close')
  }


  dropdownValues() {
    const dropdownData = localStorage.getItem("AdvancedropdownData");
    if (!dropdownData) {
      this.apiservices.getAdvanceDropdowndata().subscribe({
        next: (response: any) => {
          localStorage.setItem("AdvancedropdownData", JSON.stringify(response.data));
          // console.log('response',response)
          this.dropDownData = response.data || {};
          this.countrys = response.data.countries || [];
          this.state = response.data.states || [];
          this.city = response.data.cities || [];
          // console.log('advance_search',response)
        },
        error: (err) => {
          console.error('Error fetching states:', err);
        }
      });
    } else {
      // console.log('dropdownData',dropdownData);
      const parsedData = JSON.parse(dropdownData);
      this.dropDownData = parsedData || {};
      this.countrys = parsedData.countries || [];
      this.countrys = this.dropDownData.countries || [];
      this.state = this.dropDownData.states || [];
      this.city = this.dropDownData.cities || [];
    }

  }


}
